var Base = require('./_BaseView'),
    scope = require('scope'),
    bootstrap = require('bootstrap/dist/js/bootstrap.bundle'),
    scroll = require('../helpers/json'),
    View = Base.extend({
        template: require('templates/pages/result.hbs'),
        errorTemplate: require('templates/elements/error.hbs'),
        successTemplate: require('templates/elements/success.hbs'),
        name: 'result',
        behaviors: {
            Form: require('../behaviors/Form')
        },
        ui: {
            'form': '#selectedPlansForm',
            'info': '.planosindicados__info-handler'
            
        },
        events: {
            'click .planosindicados__back': 'backHome',
            'click @ui.info': 'toggleInfo',
            'blur @ui.info': 'closeInfo'
        },
        partials: {},
        onAttach: function () {
            var self = this;
            scope.metrics.pageview('resultado');
            var behavior = function(val) {
                    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
                },
                option = {
                    onKeyPress: function(val, e, field, options) {
                        field.mask(behavior.apply({}, arguments), options);
                    }
                };
            self.$el.find('#telefone').mask(behavior, option);
            self.$el.find('#submitModal').on('show.bs.modal', function (event) {
                var button = $(event.relatedTarget) // Button that triggered the modal
                self.$el.find('#plano_selecionado').val(button.data('plan-id'));
                self.$el.find('#plano_selecionado_nome').val(button.data('plan-name'));
                self.$el.find('#dependentes_json').val(JSON.stringify(button.data('plan-json')));
                self.$el.find('#plan_selected').html(button.data('plan-name'));
                self.$el.find('#valor_final').val(button.data('plan-value'));
                $('html,body').css('overflow', 'hidden');
            }).on('hide.bs.modal' , function () {
                $('html,body').css('overflow', '');
            });
            for(var i in this.options.data['dados']) {
                var data = this.options.data['dados'][i];
                if (Array.isArray(data)) {
                    self.$el.find('[name="'+i+'"]').val(data.length);
                }
                 else {
                    self.$el.find('[name="'+i+'"]').val(data);       
                }
            }
            this.ui.form.on('submitSuccess', function (e, response) {
                self.$el.find('[data-dismiss="modal"]').click();
                if(response.success) {
                    var SuccessView = require('views/ContactSuccess');
                    // scope.setvars({});
                    scope.app.go(new SuccessView({}));
                } else {
                    self.$el.find('.planosindicados__title').after($(self.errorTemplate()));
                }
                
            }).on('submitError', function () {
                self.$el.find('[data-dismiss="modal"]').click();
                self.$el.find('.planosindicados__title').after($(self.errorTemplate()));
            }).on('beforeProcessRequest', function () {
                // self.$el.find('.entry-header').after($(require('templates/elements/error.hbs')));
                self.$el.find('#planosindicados-errors, #planosindicados-success').fadeOut();
            });

        },
        backHome: function (e) {
            e.preventDefault();
            scope.app.anchor(0);
            var View = require('views/Home');
            scope.app.go(new View({}));
        },
        onDomRefresh: function () {
            var self = this;
            if ( self.$el.find("#table-cobertura").length) {
                var tableOffset1 = self.$el.find("#table-cobertura").offset().top;
                var $header1 = self.$el.find("#table-cobertura > thead").clone();
                var $fixedHeader1 = self.$el.find("#header-fixed1").append($header1);
        
                var tableOffset2 = self.$el.find("#table-acomodacao").offset().top;
                var $header2 = self.$el.find("#table-acomodacao > thead").clone();
                var $fixedHeader2 = self.$el.find("#header-fixed2").append($header2);
        
                var tableOffset3 = self.$el.find("#table-coparticipacao").offset().top;
                var $header3 = self.$el.find("#table-coparticipacao > thead").clone();
                var $fixedHeader3 = self.$el.find("#header-fixed3").append($header3);
        
                var tableOffset4 = self.$el.find("#table-carencias").offset().top;
                var $header4 = self.$el.find("#table-carencias > thead").clone();
                var $fixedHeader4 = self.$el.find("#header-fixed4").append($header4);
        
                var tableOffset5 = self.$el.find("#table-valores").offset().top;
                var $header5 = self.$el.find("#table-valores > thead").clone();
                var $fixedHeader5 = self.$el.find("#header-fixed5").append($header5);
        
                self.listenTo(scope.app,  'scroll', function (args) {
                        var offset = args.top;
            
                        if (offset >= tableOffset1 && $fixedHeader1.is(":hidden"))
                            $fixedHeader1.show();
                        else if (offset < tableOffset1)
                            $fixedHeader1.hide();
            
                        if (offset >= tableOffset2 && $fixedHeader2.is(":hidden"))
                            $fixedHeader2.show();
                        else if (offset < tableOffset2)
                            $fixedHeader2.hide();
            
                        if (offset >= tableOffset3 && $fixedHeader3.is(":hidden"))
                            $fixedHeader3.show();
                        else if (offset < tableOffset3)
                            $fixedHeader3.hide();
            
                        if (offset >= tableOffset4 && $fixedHeader4.is(":hidden"))
                            $fixedHeader4.show();
                        else if (offset < tableOffset4)
                            $fixedHeader4.hide();
            
                        if (offset >= tableOffset5 && $fixedHeader5.is(":hidden"))
                            $fixedHeader5.show();
                        else if (offset < tableOffset5)
                            $fixedHeader5.hide();
                });
            }
        },
        toggleInfo: function(e){
            $(e.currentTarget).parents('.planosindicados__info').toggleClass('open');
        },
        closeInfo: function(e){
            $(e.currentTarget).parents('.planosindicados__info').removeClass('open');
        }
    });
module.exports = View;



// WEBPACK FOOTER //
// ./resources/scripts/views/Result.js